import React, { Dispatch, useCallback, useState } from 'react';
import {
  BundlePackagesEnum,
  IntegrationPackagesEnum,
} from '../customization-page-v2.types';
import { BundleAddOnsEnum } from '../customization-page.utils';

export type BundleType = 'new' | 'old';

export type TableFilterState = {
  isSoftwareOnly: boolean;
  bundleType: BundleType;
  integration: IntegrationPackagesEnum;
  phones: boolean;
  addOns: BundleAddOnsEnum[];
  oldBundlePackage: BundlePackagesEnum;
};

const defaultTableFilterState: TableFilterState = {
  isSoftwareOnly: false,
  bundleType: 'new',
  integration: IntegrationPackagesEnum.PLUS,
  phones: true,
  addOns: [BundleAddOnsEnum.BASE],
  oldBundlePackage: BundlePackagesEnum.ULTIMATE,
};

export const CustomizationFlagTableFilterContext = React.createContext<{
  filters: TableFilterState;
  updateFilters: Dispatch<Partial<TableFilterState>>;
  resetFilters: () => void;
}>({
  filters: defaultTableFilterState,
  updateFilters: (filters) => {},
  resetFilters: () => {},
});

export const CustomizationFlagTableFilterProvider = ({ children }) => {
  const [tableFilterState, setTableFilterState] = useState<TableFilterState>(
    defaultTableFilterState
  );

  const updateFilters = useCallback((filters: Partial<TableFilterState>) => {
    setTableFilterState((state) => ({ ...state, ...filters }));
  }, []);

  const resetFilters = useCallback(() => {
    setTableFilterState(defaultTableFilterState);
  }, []);

  return (
    <CustomizationFlagTableFilterContext.Provider
      value={{
        filters: tableFilterState,
        updateFilters,
        resetFilters,
      }}
    >
      {children}
    </CustomizationFlagTableFilterContext.Provider>
  );
};

export const useCustomizationTableFilter = () =>
  React.useContext(CustomizationFlagTableFilterContext);
